import React , { useState,useEffect  } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link ,Navigate,useParams } from "react-router-dom";
import withRouter from "Components/Common/withRouter";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunk";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/darklogo.png";
import { createSelector } from 'reselect';

const PasswordReset = (props) => {

    const navigate = useNavigate();
    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    const { uuid } = useParams();
    const [valid, setValid] = useState<boolean | null>(null);
    const [isSending, setIsSending] = useState(false);    
    const [passwordData, setPasswordData] = useState({password: "", confirmPassword: ""});



    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        setIsSending(true);
        e.preventDefault();
        if (passwordData.password !== passwordData.confirmPassword) {
            setAlertMsgg({ ...alertMsgg, open: true, content: `Password do not match !`, type: "success" });
            setTimeout(()=>{
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 3000)
            return;
        }
        const user_id = localStorage.getItem("passwordemail")
        try {
            const res = await axios.post("/accounts/forgot_password_reset", {
                email :user_id, 
                uuid : uuid,
                password: passwordData.password,
                confirm_password : passwordData.confirmPassword
            });

            if(res.status === "success"){
                setAlertMsgg({ ...alertMsgg, open: true, content: `Hi ${res.msg}, Please wait.`, type: "success" });
                setTimeout(()=>{
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000)
                setIsSending(false);
                setTimeout(()=>{
                    navigate('/login')
                }, 4000)
                localStorage.removeItem("passwordemail")
            }
        } catch (err:any) {
            if (err.response.data.status === 'ierror') {
                if ([401, 422].includes(err.response.data.error)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: err.response.data.error, type: "error" });
                } else if (err.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else if (err.response.status === 400) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: err.response.data.error, type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
        }
    };


    const password_r = async () => {
        try {
            const response = await axios.get(`/accounts/forgot_password_verify/${uuid}`);
            console.log("check kro response", response);

            if (response.status === "valid_token") {
                localStorage.setItem("passwordemail",response.user_id)
                setValid(true);
                setAlertMsgg({ ...alertMsgg, open: true, content: `Hi ${response.user_id}`, type: "success" });
                setTimeout(()=>{
                    setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
                }, 4000)
            } else {
                setValid(false);
            }
        } catch (err:any) {
            if (err.response.data.status === 'ierror') {
                if ([401, 422].includes(err.response.data.error)) {
                    console.log('Error in stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: err.response.data.error, type: "error" });
                } else if (err.response.status === 403) {
                    console.log('Error stripe payment')
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else if (err.response.status === 400) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: err.response.data.error, type: "error" });
                    setTimeout(()=>{window.location.href="/logout"}, 2000)
                } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                console.log('An error occurred')
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }

            setValid(false);
        }
    };
    useEffect(() => {

        if (uuid) password_r();
    }, [uuid]);





    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);

    //meta title
    document.title = "Forget Password | BizServe";


    return (
        <React.Fragment>
            <div className="account-pages fullpagebg my-md-0 my-5 pt-sm-5">
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        style={{ fontWeight: "bold" }}
                        fade={false}
                        
                        >
                        {alertMsgg.content}
                    </Alert>
                )}
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary-subtle bgImgGradient">
                                    <Row>
                                        <Col xs={7}>
                                            <div className="text-dark p-4">
                                                <h5 className="text-dark">Welcome Back !</h5>
                                                <p>Sign in to continue to BizServe.</p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img src={profile} alt="" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div>
                                        <Link to="/">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={logo}
                                                        alt=""
                                                        className=""
                                                        height="38"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">
                                        <Form
                                            className="form-horizontal" onSubmit={handleSubmit}>
                                            <div className="mb-3">
                                                <Label className="form-label">Enter New Password<span className="text-danger px-1">*</span></Label>
                                                <div className="input-group auth-pass-inputgroup">
                                                    <Input
                                                    name="password"
                                                    type={show ? "text" : "password"}
                                                    placeholder="Enter Password"
                                                    value={passwordData.password}
                                                    onChange={handleChange}
                                                    />
                                                    <button onClick={() => setShow(!show)} className="btn btn-light " type="button" id="password-addon">
                                                    <i className="mdi mdi-eye-outline"></i></button>
                                                </div>
                                                <small className="text-muted d-block mt-2">
                                                    <strong>Password Requirements:</strong>
                                                    <ul className="mb-0 ps-3" style={{ fontSize: "0.85rem" }}>
                                                        <li>At least 6 characters</li>
                                                        <li>One uppercase letter (A-Z)</li>
                                                        <li>One number (0-9)</li>
                                                        <li>One special character (!@#$%^&*...)</li>
                                                    </ul>
                                                </small>
                                            </div>
                                            <div className="mb-3">
                                                <Label className="form-label">Re Enter New Password<span className="text-danger px-1">*</span></Label>
                                                <div className="input-group auth-pass-inputgroup">
                                                    <Input
                                                    name="confirmPassword"
                                                    type={show1 ? "text" : "password"}
                                                    placeholder="Enter Password"
                                                    value={passwordData.confirmPassword}
                                                    onChange={handleChange}

                                                    />
                                                    <button onClick={() => setShow1(!show1)} className="btn btn-light " type="button" id="password-addon">
                                                    <i className="mdi mdi-eye-outline"></i></button>
                                                </div>
                                            </div>
                                            <Row className="mb-3">
                                                <Col className="text-end">
                                                    <button
                                                        className="btn btn-primary w-md "
                                                        type="submit"
                                                        disabled={isSending}
                                                    >
                                                        {isSending ? "Saveing..." : "Save"}
                                                    </button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>
                                    Go back to{" "}
                                    <Link to="/login" className="font-weight-medium text-primary">
                                        Login
                                    </Link>{" "}
                                </p>
                                <p>
                                    © {new Date().getFullYear()} BizServe. Crafted with{" "}
                                    <i className="mdi mdi-heart text-danger" /> by BizServe LLC
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(PasswordReset);